import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { BlandPoint } from '../../types/voip';
const COLORS = {
  transfers: '#f2b8dc',
  opportunities: '#be188c',
  grid: '#eef2f6',
  axis: '#8c99a7'
};
const legend = [{
  label: 'Transferred to LO',
  color: COLORS.transfers
}, {
  label: 'Opportunities created',
  color: COLORS.opportunities
}];
interface BlandTrendChartProps {
  data: BlandPoint[];
  title: string;
}
export function BlandTrendChart({
  data,
  title
}: BlandTrendChartProps) {
  return <section aria-label={title} className="flex h-full flex-col rounded-2xl border border-line bg-surface p-6 shadow-card" data-id="element-70" data-mp="1jr7holjlcjr7">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3" data-id="element-71" data-mp="1ezxxw1kq4an8">
        <h2 className="text-base font-semibold text-ink" data-id="element-72" data-mp="rawq8gjpt3j0">{title}</h2>
        <ul className="flex flex-wrap items-center gap-4" data-id="element-73" data-mp="r924j00md7dv">
          {legend.map(l => <li key={l.label} className="flex items-center gap-1.5 text-xs text-muted" data-id="element-74" data-mp="mbjvzaqiku6e">
              <span className="h-2.5 w-2.5 rounded-sm" style={{
            backgroundColor: l.color
          }} aria-hidden data-id="element-75" data-mp="15ab0w5za90mf" />
              {l.label}
            </li>)}
        </ul>
      </div>
      <div className="h-72 w-full flex-1" data-id="element-76" data-mp="1e45x2oiffgpx">
        <ResponsiveContainer width="100%" height="100%" data-id="element-77" data-mp="1e5gyihoegcdv">
          <BarChart data={data} margin={{
          top: 4,
          right: 0,
          left: -18,
          bottom: 0
        }} barGap={2} barCategoryGap={data.length > 12 ? '18%' : '30%'} data-id="element-78" data-mp="1j164b2r0ipim">
            <CartesianGrid vertical={false} stroke={COLORS.grid} data-id="element-79" data-mp="meb6koiu1kzo" />
            <XAxis dataKey="label" tickLine={false} axisLine={false} tick={{
            fontSize: 12,
            fill: COLORS.axis
          }} interval="preserveStartEnd" minTickGap={14} dy={6} data-id="element-80" data-mp="qe22f6n7urb2" />
            <YAxis tickLine={false} axisLine={false} allowDecimals={false} tick={{
            fontSize: 12,
            fill: COLORS.axis
          }} data-id="element-81" data-mp="10bzrtxgtau59" />
            <Tooltip cursor={{
            fill: 'rgba(190,24,140,0.05)'
          }} contentStyle={{
            borderRadius: 10,
            border: '1px solid #e4e9ef',
            fontSize: 12
          }} data-id="element-82" data-mp="26r0ch70dzpwj" />
            <Bar dataKey="transfers" name="Transferred to LO" fill={COLORS.transfers} radius={[3, 3, 0, 0]} animationDuration={300} animationEasing="ease-out" data-id="element-83" data-mp="1m1y17rqembpo" />
            <Bar dataKey="opportunities" name="Opportunities created" fill={COLORS.opportunities} radius={[3, 3, 0, 0]} animationDuration={300} animationEasing="ease-out" data-id="element-84" data-mp="1w0x38rgnz93p" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>;
}